const projects = [
  {
    title: "TBCare",
    url:
      "https://gitlab.cs.ui.ac.id/ppl-fasilkom-ui/2020/ppl-c/ppti-mobile-apps-monitoring-wabah-tuberkolosis/",
    content:
      "Masterpiece award winning TBCare is a tuberculosis case monitoring system. This application consists of a mobile app and a web dashboard built with React, and a backend service built with Django REST.",
    onDisplay: true,
  },
  {
    title: "ReversAI",
    url: "https://gitlab.com/reversai/reversi-ai",
    content:
      "ReversAI is an AI-Powered reversi playing agent built with ReactJS using MiniMax Algorithm with Alpha-Beta Pruning. Accessible through https://reversai.netlify.app/ .",
    onDisplay: true,
  },
  {
    title: "Conway's Game of Life",
    url: "https://gitlab.cs.ui.ac.id/game-of-life",
    content:
      "A functional programming implementation of the famous Game of Life - a simulation of entity generation and degeneration. Accessible through https://game-of-life-pf.netlify.app/ .",
    onDisplay: true,
  },
  {
    title: "Impulse",
    url: "https://gitlab.com/impulse_bot/",
    content:
      "Impulse is a To-Do Assistant Manager that is available as a Line Bot. It was built using Java Spring Framework and consisted of 2 services: RestAPI and Line Handler.",
    onDisplay: true,
  },
  {
    title: "Musica",
    url: "https://gitlab.com/musica-raspi-sysprog/",
    content:
      "Musica is a real-time shared music player platform built with Raspberry Pi 3+. It enables the user to manipulate the shared song queue and add new songs from Youtube.",
    onDisplay: true,
  },
  {
    title: "Portfolio CMS",
    url: "https://github.com/Jonathanjojo19/PortfolioCMS",
    content:
      "A Django based minimalist portfolio page with an admin page to edit the contents. The owner can set and display information such as name, introduction message, page title, contacts, and projects.",
    onDisplay: true,
  },
  {
    title: "Store Manager",
    url: "https://github.com/WebStoreGroup/Web-Store-Manager",
    content:
      "I worked on Web Store Manager's back end side: providing API views and permissions handling using Django-REST API. It is used as a usable template for online stores to monitor, display, and manage their own online store.",
    onDisplay: false,
  },
];

export default projects;
